import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Avatar,
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import LogoIcon from "../../../assets/images/logo-icon.png";
import variables from "../../../assets/styles/variables.module.scss";
import TypingIndicator from "../../../Shared-ui/SharedComponents/TypingIndicator";
import LineMdAccount from "../../../assets/icons/LineMdAccount";
import { Params, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  StartLoading,
  StopLoading,
} from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import { Agent, AgentTheme } from "../../../Shared-ui/Types/Agent";
import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import { AGENT, AGENT_SHORTCUT, CHAT_HISTORY, CHAT_HISTORY_DETAIL } from "../../../Services/Endpoint";
import { ShowError } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import PlayGroundInitialMessage from "../../Components/PlayGroundIntialMessage";
import { Message, UserMessage } from "../../../Shared-ui/Types/PlayGround";
import { v4 as uuidv4 } from "uuid";
import { PlayGroundEnum } from "../../../Shared-ui/Enum/PlayGroundEnum";
import { GetSession } from "../../../Shared-ui/utils/Auth/AuthHelpers";
import { marked, use } from "marked";
import AgentPlayGroundTools from "../../Components/AgentPlayGroundTools";
import AgentPlaygroundReferences from "../../Components/AgentPlaygroundReferences";
import CachedIcon from "@mui/icons-material/Cached";
import AgentQuestions from "../../Components/AgentQuestions";
import AgentPrompts from "../../Components/AgentPromts";
import striptags from "striptags";
import PlotlyChart from "../../Components/PlotlyChart";
import { capitalizeFirstLetter } from "../../../Shared-ui/utils/Common/Common";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EndChatIcon from "../../../assets/icons/EndChatIcon";
import NewChatIcon from "../../../assets/icons/NewChatIcon";
import RecentChatIcon from "../../../assets/icons/RecentChatIcon";
// import RecentChats from "../../Components/RecentChats";
import RecentChatsByUser from "../../Components/RecentsChatsByUser/index";
import VoiceRecorder from "../../../Shared-ui/SharedComponents/VoiceRecorder";
import { audioBlobToBase64 } from "../../../utils/audioUtils";

type ChatHistoryItem = {
  id: string;
  user_id: string;
  agent_id: string;
  agent_name: string;
  conversation_id: string;
  message_count: number;
  first_message_preview: string;
  last_message_preview: string;
  created_at: string;
  organization_id: string | null;
};

// Add this type for chat history details
type ChatHistoryDetail = {
  id: string;
  user_id: string;
  agent_id: string;
  agent_name: string;
  conversation_id: string;
  messages: Array<{
    user_message: string;
    agent_response: {
      response: string;
      conversation_id: string;
      metadata: {
        tool_calls: any[];
        context: any;
        metrics: any;
        model: string;
        extra_data: any;
        is_chartable: boolean;
      };
    };
  }>;
  message_count: number;
  created_at: string;
  organization_id: string | null;
};

// const ALL_CHIPS = [
//   "Summarize",
//   "Shorten",
//   "Rephrase",
//   "Bullet Points",
//   "Highlight",
//   "Simplify",
//   "Expand",
// ];

const IFrameAgent: React.FC = () => {
  const { agentId, apiKey } = useParams<Params>();

  const dispatch = useDispatch();
  const uniqueId = uuidv4();
  const [initialMessage, setInitialMessage] = useState<string>("");
  const [agents, setAgents] = useState<Agent>();
  const [userInput, setUserInput] = useState<string>("");
  const [botTyping, setBotTyping] = useState<boolean>(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const [messages, setMessages] = useState<Message[]>([]);
  const [agentShortcuts, setAgentShortcuts] = useState<any>([]);
  const endOfMessagesRef = useRef<HTMLDivElement>(null);
  const [conversationId, setConversationId] = useState<string>("");
  const [chatHistoryId, setChatHistoryId] = useState<string>("");
  const [showQuestions, setShowQuestions] = useState<boolean>(true);
  const [showInitialMessage, setShowInitialMessage] = useState(true);
  const [showCitations, setShowCitations] = useState<boolean>(false);
  const [bubbleColor, setBubbleColor] = useState(variables.primaryColor);
  const [incomingTextColor, setIncomingTextColor] = useState("#000000");
  const [outgoingTextColor, setOutgoingTextColor] = useState("#000000");
  const [titleColor, setTitleColor] = useState("#000000");
  const [profileImage, setProfileImage] = useState<string | null>(null);
  const [showHistory, setShowHistory] = React.useState(false);
  const [userId, setUserId] = useState<string | null>("");
  const [guestUserId, setGuestUserId] = useState<string | null>("");
  console.log(guestUserId, "guestUserId onload");
  console.log(userId, "userId onload");
  const isCancelledStream = useRef<boolean>(true);
  const [agentTheme, setAgentTheme] = useState<AgentTheme>({
    backgroundColor: "#ffffff",
    titleColor: "#000000",
    outgoingChatTextColor: "#000000",
    incomingChatTextColor: "#000000",
    chatBubbleButtonColor: variables.primaryColor,
    mode: "single",
    angle: 180
  });
  const responseId = useRef<string>('');


  const [pageContext, setPageContext] = useState<{
    html: string;
    url: string;
    title: string;
  } | null>(null);
  const [userContext, setUserContext] = useState<any>(null);
  const [isVoiceMode, setIsVoiceMode] = useState<boolean>(false);
  const [currentAudioUrl, setCurrentAudioUrl] = useState<string | null>(null);

  const cleanShortcutLabel = (raw: string) => {
    if (!raw) return raw;


    const match = raw.match(/PostResponseAction\.(.*?)]/);
    if (match && match[1]) {
      return `<i>${capitalizeFirstLetter(match[1])}</i>`;
    }

    return raw;
  };

  const cleanShortcutPreview = (text: string) => {
    if (!text) return text;

    const match = text.match(/PostResponseAction\.(.*?)\]/);

    if (match && match[1]) {
      return match[1].charAt(0).toUpperCase() + match[1].slice(1);
    }

    return text;
  };



  useEffect(() => {
    const scrollBehavior = botTyping ? "auto" : "smooth";
    endOfMessagesRef.current?.scrollIntoView({ behavior: scrollBehavior });
  }, [messages.length, botTyping]);

  useEffect(() => {
    getAgent();
    getAgentShortCut();
  }, [agentId]);

  // Load chat history ID from localStorage on component mount
  useEffect(() => {
    if (agentId && userContext?.id) {
      const userId = userContext.id; // Extract to local variable
      const storageKey = `zeaiq_chat_history_${agentId}_${userId}`;
      const storedChatHistoryId = localStorage.getItem(storageKey);
      if (storedChatHistoryId) {
        setChatHistoryId(storedChatHistoryId);
        console.log('📚 Loaded chat history ID from localStorage:', storedChatHistoryId);
      }
    }
  }, [agentId, userContext?.id]);

  // Save chat history ID to localStorage when it changes
  useEffect(() => {
    if (chatHistoryId && agentId && userContext?.id) {
      const userId = userContext.id; // Extract to local variable
      const storageKey = `zeaiq_chat_history_${agentId}_${userId}`;
      localStorage.setItem(storageKey, chatHistoryId);
      console.log('💾 Saved chat history ID to localStorage:', chatHistoryId);

      // Also notify parent window about the chat history update
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({
          type: 'CHAT_HISTORY_UPDATED',
          agentId: agentId,
          userId: userId,
          chatHistoryId: chatHistoryId
        }, '*');
        console.log('🔄 Notified parent window about chat history update');
      }
    }
  }, [chatHistoryId, agentId, userContext?.id]);

  useEffect(() => {
    if (!botTyping) {
      inputRef.current?.focus();
    }
  }, [messages, botTyping]);

  // Listen for post messages from parent window
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      console.log('🔄 Iframe received message:', event.data);

      // Verify the message is from the expected origin (parent window)
      // Allow null origin for local file system and localhost origins
      // if (event.origin !== window.location.origin &&
      //   event.origin !== 'null' &&
      //   !event.origin.includes('localhost') &&
      //   event.origin !== '') {
      //   console.log('⚠️ Message origin not trusted:', event.origin);
      //   return;
      // }

      if (event.data.type === 'PAGE_CONTENT') {
        console.log('✅ Received page content from parent:', {
          html: event.data.html,
          url: event.data.url,
          title: event.data.title
        });

        // Store the page content in state for use in chat
        const newPageContext = {
          html: event.data.html,
          url: event.data.url,
          title: event.data.title
        };

        console.log('📄 Setting pageContext to:', newPageContext);
        setPageContext(newPageContext);

        // Show visual feedback that page context was updated
        if (pageContext && pageContext.url !== newPageContext.url) {
          console.log('🔄 Page context updated - user navigated to new page');
          // You could add a toast notification here if desired
        }

        // Send confirmation back to parent window
        if (window.parent && window.parent !== window) {
          window.parent.postMessage({
            type: 'PAGE_CONTENT_RECEIVED',
            message: 'Page content successfully received by iframe',
            data: {
              html: event.data.html,
              url: event.data.url,
              title: event.data.title
            }
          }, '*');
          console.log('✅ Confirmation sent back to parent');
        }
      } else if (event.data.type === 'USER_DATA') {
        console.log('✅ Received user data from parent:', event.data.data);

        // Store the user data in state for use in chat
        setUserContext(event.data.data);

        // Send confirmation back to parent window
        if (window.parent && window.parent !== window) {
          window.parent.postMessage({
            type: 'USER_DATA_RECEIVED',
            message: 'User data successfully received by iframe',
            data: event.data.data
          }, '*');
          console.log('✅ User data confirmation sent back to parent');
        }
      } else if (event.data.type === 'REQUEST_GUEST_USER_DATA') {
        console.log('👤 Received request for guest user data generation');

        // Generate guest user data
        const guestUserId = crypto.randomUUID();
        const guestUserData = {
          id: guestUserId,
          name: 'Guest User',
          email: `${guestUserId}@dummy.zeaiq.com`,
          type: 'guest',
          timestamp: new Date().toISOString()
        };
        console.log('👤 Generated guest user data:', guestUserData);

        // Send the generated guest user data back to parent window
        if (window.parent && window.parent !== window) {
          window.parent.postMessage({
            type: 'GUEST_USER_DATA_GENERATED',
            message: 'Guest user data successfully generated',
            data: guestUserData
          }, '*');
          console.log('✅ Guest user data sent back to parent');
        }
      } else if (event.data.type === 'CHAT_HISTORY_ID') {
        console.log('📚 Received chat history ID from parent:', event.data.data);

        // Set the chat history ID from parent window
        const { agentId, userId, chatHistoryId } = event.data.data;
        if (agentId && userId && chatHistoryId) {
          setChatHistoryId(chatHistoryId);
          console.log('📚 Set chat history ID from parent:', chatHistoryId);
        }
      } else {
        console.log('ℹ️ Received message with type:', event.data.type);
      }
    };

    console.log('🔄 Setting up message listener in iframe');
    window.addEventListener('message', handleMessage);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  // Debug: Log when pageContext changes
  useEffect(() => {
    if (pageContext) {
      console.log('📄 Page context updated in iframe:', {
        title: pageContext.title,
        url: pageContext.url,
        htmlLength: pageContext.html.length
      });
    } else {
      console.log('📄 Page context is null in iframe');
    }
  }, [pageContext]);

  // Debug: Log when userContext changes
  useEffect(() => {
    if (userContext) {
      console.log('👤 User context updated in iframe:', userContext);
      setUserId(userContext.id);
      console.log(userId, "userId loaded");
    } else {
      console.log('👤 User context is null in iframe');
    }
  }, [userContext]);

  const getAgent = async () => {
    try {
      dispatch(StartLoading());
      const response = await fetch(`${AGENT}/${agentId}`, {
        method: "GET",
        headers: {
          "x-api-key": `${apiKey}`,
          "Content-Type": "application/json",
          Accept: "text/event-stream",
        },
        mode: "cors",
        credentials: "same-origin",
      });
      const data = await response.json();
      setInitialMessage(`Hello! How can I assist you today?`);
      setAgents(data);
      setAgentTheme(data.agent_metadata?.agent_theme || agentTheme);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }
  };

  const getAgentShortCut = async () => {
    try {
      dispatch(StartLoading());
      const response = await fetch(`${AGENT_SHORTCUT}`, {
        method: "GET",
        headers: {
          "x-api-key": `${apiKey}`,
          "Content-Type": "application/json",
          Accept: "text/event-stream",
        },
        mode: "cors",
        credentials: "same-origin",
      });
      const data = await response.json();
      // const data = await BaseInstance.get(`${AGENT_SHORTCUT}`)

      setAgentShortcuts(data || []);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }
  };
  const sendMessageQuestions = async (question: string) => {
    isCancelledStream.current = false;
    setShowInitialMessage(false);
    setShowQuestions(false);

    // Check if userContext is available, if not, generate a guest user
    if (!userContext) {
      console.log('👤 No user context available, generating guest user for question');
      const guestUserId = crypto.randomUUID();
      const guestUserData = {
        id: guestUserId,
        name: 'Guest User',
        email: `${guestUserId}@dummy.zeaiq.com`,
        type: 'guest',
        timestamp: new Date().toISOString()
      };
      setUserContext(guestUserData);
      setUserId(guestUserId);

      // Notify parent window about guest user generation
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({
          type: 'GUEST_USER_GENERATED',
          message: 'Guest user generated for question',
          data: guestUserData
        }, '*');
      }
    }

    const data: UserMessage = {
      input: question,
      conversation_id: conversationId ? conversationId : "",
    };

    // Create the request payload for the API
    const requestPayload = {
      input: question,
      conversation_id: conversationId ? conversationId : "",
      chat_history_id: chatHistoryId || undefined,
      metadata: {
        ...(pageContext && { page_context: pageContext }),
        ...(userContext && { user_context: userContext })
      }
    };

    // Add user message
    setMessages((prev) => [
      ...prev,
      { sender: PlayGroundEnum.USER, userData: data },
    ]);
    setUserInput("");
    setBotTyping(true);
    try {
      if (agents?.agent_metadata?.streaming) {
        const response = await fetch(
          `${AGENT}/${agentId}/execute?stream=true`,
          {
            method: "POST",
            headers: {
              "x-api-key": `${apiKey}`,
              "Content-Type": "application/json",
              Accept: "text/event-stream",
            },
            body: JSON.stringify(requestPayload),
            mode: "cors",
            credentials: "same-origin",
          }
        );

        if (!response.ok || !response.body) {
          throw new Error("Failed to stream");
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");

        // Add placeholder agent message
        setMessages((prev) => [...prev, { sender: PlayGroundEnum.AGENT, isMessageLike: null }]);

        let buffer = "";
        var content = "";
        var tool_calls: any[] = [];
        var references: any[] = [];

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          if (isCancelledStream.current) break;

          buffer += decoder.decode(value, { stream: true });

          const lines = buffer.split("\n");
          for (const line of lines) {
            if (line.startsWith("data: ")) {
              const jsonPart = line.replace(/^data: /, "").trim();

              if (jsonPart === "[DONE]") return;

              try {
                const parsed = JSON.parse(jsonPart);
                responseId.current = parsed.response_id;
                if (!parsed.is_complete) {
                  content += parsed.response; // Assign directly here
                  setConversationId(parsed.conversation_id);
                  tool_calls = parsed.metadata.tool_calls || [];
                  const sanitizedContent = await marked.parse(content);
                  setMessages((preVal) => {
                    let lastMsg = preVal[preVal.length - 1];
                    lastMsg = {
                      ...lastMsg,
                      agentData: {
                        response: sanitizedContent,
                        conversation_id: parsed.conversation_id,
                        response_id: parsed.response_id,
                        rawResponse: content,
                        metadata: {
                          tool_calls: tool_calls,
                          extra_data: { references: references },
                        },
                      },
                    };
                    // console.log(lastMsg)
                    return [...preVal.slice(0, preVal.length - 1), lastMsg];
                  });
                } else {
                  // Handle completion - extract chat history ID and other metadata
                  if (parsed.chat_history_id) {
                    setChatHistoryId(parsed.chat_history_id);
                    console.log('📚 Received chat history ID from streaming response:', parsed.chat_history_id);
                  }

                  if (parsed.metadata?.extra_data?.references) {
                    references = parsed.metadata.extra_data.references;
                    setMessages((preVal) => {
                      let lastMsg = preVal[preVal.length - 1];
                      lastMsg = {
                        ...lastMsg,
                        agentData: {
                          ...lastMsg.agentData,
                          response: lastMsg.agentData?.response || "",
                          conversation_id: lastMsg.agentData?.conversation_id || "",
                          response_id: lastMsg.agentData?.response_id || parsed.response_id,
                          metadata: {
                            tool_calls: tool_calls,
                            extra_data: { references: references },
                          },
                        },
                      };
                      // console.log(lastMsg)
                      return [...preVal.slice(0, preVal.length - 1), lastMsg];
                    });
                  }
                  if (parsed.is_chart && parsed.response) {
                    try {
                      const chartData = JSON.parse(parsed.response);
                      setMessages((preVal) => {
                        let lastMsg = preVal[preVal.length - 1];
                        lastMsg = {
                          ...lastMsg,
                          agentData: {
                            response: "",
                            rawResponse: parsed.response,
                            response_id: parsed.response_id,
                            chartData: chartData,
                            metadata: {
                              tool_calls: tool_calls,
                              extra_data: { references: references },
                            },
                          },
                        };
                        return [...preVal.slice(0, preVal.length - 1), lastMsg];
                      });
                    } catch (chartError) {
                      console.error("Failed to parse chart data:", chartError);
                    }
                  }
                }
              } catch (e) {
                console.error("Parse error:", jsonPart, e);
              }
            }
          }

          // Keep partial buffer (in case a line is split across chunks)
          buffer = lines[lines.length - 1];
        }
      } else {
        // streming is false

        const resData: any = await fetch(
          `${AGENT}/${agentId}/execute?stream=false`,
          {
            method: "POST",
            headers: {
              "x-api-key": `${apiKey}`,
              "Content-Type": "application/json",
              Accept: "text/event-stream",
            },
            body: JSON.stringify(requestPayload),
            mode: "cors",
            credentials: "same-origin",
          }
        );

        if (!resData.ok) {
          throw new Error("Failed to stream");
        }
        const responseData = await resData.json();
        responseId.current = responseData.response_id;
        setConversationId(responseData.conversation_id);

        // Extract chat history ID if present
        if (responseData.chat_history_id) {
          setChatHistoryId(responseData.chat_history_id);
          console.log('📚 Received chat history ID from non-streaming response:', responseData.chat_history_id);
        }

        const rawHtml: string = await marked.parse(responseData.response);
        const tool_calls = responseData.metadata.tool_calls || [];
        const extra_data = responseData.metadata.extra_data;
        console.log(responseData);
        setMessages((preVal) => {
          return [
            ...preVal,
            {
              sender: PlayGroundEnum.AGENT,
              agentData: {
                response: rawHtml,
                rawResponse: responseData.response,
                conversation_id: responseData.conversation_id,
                response_id: responseData.response_id,
                metadata: { tool_calls: tool_calls, extra_data: extra_data },
              },
            },
          ];
        });
        if (responseData.is_chart && responseData.response) {
          try {
            const chartData = JSON.parse(responseData.response);
            setMessages((preVal) => {
              return [
                ...preVal,
                {
                  sender: PlayGroundEnum.AGENT,
                  agentData: {
                    response: "",
                    rawResponse: responseData.response,
                    response_id: responseData.response_id,
                    chartData: chartData,
                    metadata: { tool_calls: tool_calls, extra_data: extra_data },
                  },
                },
              ];
            });
          } catch (chartError) {
            console.error("Failed to parse chart data:", chartError);
          }
        }
      }
    } catch (err) {
      console.error("Streaming failed:", err);
    } finally {
      setBotTyping(false);
    }
  };

  const sendMessageShortcuts = async (shortcut: string, messageId: number) => {
    isCancelledStream.current = false;
    setShowQuestions(false);

    // Check if userContext is available, if not, generate a guest user
    if (!userContext) {
      console.log('👤 No user context available, generating guest user for shortcut');
      const guestUserId = crypto.randomUUID();
      const guestUserData = {
        id: guestUserId,
        name: 'Guest User',
        email: `${guestUserId}@dummy.zeaiq.com`,
        type: 'guest',
        timestamp: new Date().toISOString()
      };
      setUserContext(guestUserData);
      setUserId(guestUserId);

      // Notify parent window about guest user generation
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({
          type: 'GUEST_USER_GENERATED',
          message: 'Guest user generated for shortcut',
          data: guestUserData
        }, '*');
      }
    }

    const message = messages[messageId];
    const plainText = striptags(message.agentData?.response || "");
    const data: UserMessage = {
      input: `<i>${capitalizeFirstLetter(shortcut)}</i>`,
      action: shortcut,
      original_content: plainText,
      conversation_id: conversationId ? conversationId : "",
    };

    // Create the request payload for the API
    const requestPayload = {
      input: capitalizeFirstLetter(shortcut),
      action: shortcut,
      original_content: plainText,
      conversation_id: conversationId ? conversationId : "",
      chat_history_id: chatHistoryId || undefined,
      metadata: {
        ...(pageContext && { page_context: pageContext }),
        ...(userContext && { user_context: userContext })
      }
    };


    // Add user message
    setMessages((prev) => [
      ...prev,
      { sender: PlayGroundEnum.USER, userData: data }
    ]);
    setUserInput("");
    setBotTyping(true);
    try {
      if (agents?.agent_metadata?.streaming) {
        const response = await fetch(
          `${AGENT}/${agentId}/post-response-shortcut?stream=true`,
          {
            method: "POST",
            headers: {
              "x-api-key": `${apiKey}`,
              "Content-Type": "application/json",
              Accept: "text/event-stream",
            },
            body: JSON.stringify(requestPayload),
            mode: "cors",
            credentials: "same-origin",
          }
        );

        if (!response.ok || !response.body) {
          throw new Error("Failed to stream");
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");

        // Add placeholder agent message
        setMessages((prev) => [...prev, { sender: PlayGroundEnum.AGENT, isMessageLike: null }]);

        let buffer = "";
        var content = "";
        var tool_calls: any[] = [];
        var references: any[] = [];

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          if (isCancelledStream.current) break;

          buffer += decoder.decode(value, { stream: true });

          const lines = buffer.split("\n");
          for (const line of lines) {
            if (line.startsWith("data: ")) {
              const jsonPart = line.replace(/^data: /, "").trim();

              if (jsonPart === "[DONE]") return;

              try {
                const parsed = JSON.parse(jsonPart);
                responseId.current = parsed.response_id;
                if (!parsed.is_complete) {
                  content += parsed.response; // Assign directly here
                  setConversationId(parsed.conversation_id);
                  tool_calls = parsed.metadata.tool_calls || [];
                  const sanitizedContent = await marked.parse(content);
                  setMessages((preVal) => {
                    let lastMsg = preVal[preVal.length - 1];
                    lastMsg = {
                      ...lastMsg,
                      agentData: {
                        response: sanitizedContent,
                        conversation_id: parsed.conversation_id,
                        response_id: parsed.response_id,
                        rawResponse: content,
                        metadata: {
                          tool_calls: tool_calls,
                          extra_data: { references: references },
                        },
                      },
                    };
                    // console.log(lastMsg)
                    return [...preVal.slice(0, preVal.length - 1), lastMsg];
                  });
                } else {
                  // Handle completion - extract chat history ID and other metadata
                  if (parsed.chat_history_id) {
                    setChatHistoryId(parsed.chat_history_id);
                    console.log('📚 Received chat history ID from shortcut streaming response:', parsed.chat_history_id);
                  }

                  if (parsed.metadata?.extra_data?.references) {
                    references = parsed.metadata.extra_data.references;
                    setMessages((preVal) => {
                      let lastMsg = preVal[preVal.length - 1];
                      lastMsg = {
                        ...lastMsg,
                        agentData: {
                          ...lastMsg.agentData,
                          response: lastMsg.agentData?.response || "",
                          conversation_id: lastMsg.agentData?.conversation_id || "",
                          response_id: lastMsg.agentData?.response_id || parsed.response_id,
                          metadata: {
                            tool_calls: tool_calls,
                            extra_data: { references: references },
                          },
                        },
                      };
                      // console.log(lastMsg)
                      return [...preVal.slice(0, preVal.length - 1), lastMsg];
                    });
                  }
                  if (parsed.is_chart && parsed.response) {
                    try {
                      const chartData = JSON.parse(parsed.response);
                      setMessages((preVal) => {
                        let lastMsg = preVal[preVal.length - 1];
                        lastMsg = {
                          ...lastMsg,
                          agentData: {
                            response: "",
                            rawResponse: parsed.response,
                            response_id: parsed.response_id,
                            chartData: chartData,
                            metadata: {
                              tool_calls: tool_calls,
                              extra_data: { references: references },
                            },
                          },
                        };
                        return [...preVal.slice(0, preVal.length - 1), lastMsg];
                      });
                    } catch (chartError) {
                      console.error("Failed to parse chart data:", chartError);
                    }
                  }
                }
              } catch (e) {
                console.error("Parse error:", jsonPart, e);
              }
            }
          }

          // Keep partial buffer (in case a line is split across chunks)
          buffer = lines[lines.length - 1];
        }
      } else {
        // streming is false

        const resData: any = await fetch(
          `${AGENT}/${agentId}/post-response-shortcut?stream=false`,
          {
            method: "POST",
            headers: {
              "x-api-key": `${apiKey}`,
              "Content-Type": "application/json",
              Accept: "text/event-stream",
            },
            body: JSON.stringify(requestPayload),
            mode: "cors",
            credentials: "same-origin",
          }
        );

        if (!resData.ok) {
          throw new Error("Failed to stream");
        }
        const responseData = await resData.json();
        responseId.current = responseData.response_id;
        setConversationId(responseData.conversation_id);

        // Extract chat history ID if present
        if (responseData.chat_history_id) {
          setChatHistoryId(responseData.chat_history_id);
          console.log('📚 Received chat history ID from shortcut non-streaming response:', responseData.chat_history_id);
        }

        const rawHtml: string = await marked.parse(responseData.response);
        const tool_calls = responseData.metadata.tool_calls || [];
        const extra_data = responseData.metadata.extra_data;
        console.log(responseData);
        setMessages((preVal) => {
          return [
            ...preVal,
            {
              sender: PlayGroundEnum.AGENT,
              agentData: {
                response: rawHtml,
                rawResponse: responseData.response,
                conversation_id: responseData.conversation_id,
                response_id: responseData.response_id,
                metadata: { tool_calls: tool_calls, extra_data: extra_data },
              },
            },
          ];
        });
        if (responseData.is_chart && responseData.response) {
          try {
            const chartData = JSON.parse(responseData.response);
            setMessages((preVal) => {
              return [
                ...preVal,
                {
                  sender: PlayGroundEnum.AGENT,
                  agentData: {
                    response: "",
                    rawResponse: responseData.response,
                    response_id: responseData.response_id,
                    chartData: chartData,
                    metadata: { tool_calls: tool_calls, extra_data: extra_data },
                  },
                },
              ];
            });
          } catch (chartError) {
            console.error("Failed to parse chart data:", chartError);
          }
        }
      }
    } catch (err) {
      console.error("Streaming failed:", err);
    } finally {
      setBotTyping(false);
    }
  };

  const sendVoiceMessage = async (audioBlob: Blob) => {
    isCancelledStream.current = false;

    // Check if userContext is available, if not, generate a guest user
    if (!userContext) {
      console.log('👤 No user context available, generating guest user');
      const guestUserId = crypto.randomUUID();
      const guestUserData = {
        id: guestUserId,
        name: 'Guest User',
        email: `${guestUserId}@dummy.zeaiq.com`,
        type: 'guest',
        timestamp: new Date().toISOString()
      };
      setUserContext(guestUserData);
      setUserId(guestUserId);

      // Notify parent window about guest user generation
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({
          type: 'GUEST_USER_GENERATED',
          message: 'Guest user generated for chat',
          data: guestUserData
        }, '*');
      }
    }

    setShowInitialMessage(false);
    setShowQuestions(false);
    setBotTyping(true);

    try {
      // Convert audio blob to base64 using chunked approach to avoid stack overflow
      const base64Audio = await audioBlobToBase64(audioBlob);

      const requestPayload = {
        audio_data: base64Audio,
        conversation_id: conversationId ? conversationId : "",
        chat_history_id: chatHistoryId || undefined,
        metadata: {
          ...(pageContext && { page_context: pageContext }),
          ...(userContext && { user_context: userContext })
        }
      };

      console.log('🎤 Sending voice message with payload:', requestPayload);

      const response = await fetch(
        `${AGENT}/${agentId}/voice`,
        {
          method: "POST",
          headers: {
            "x-api-key": `${apiKey}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestPayload),
          mode: "cors",
          credentials: "same-origin",
        }
      );

      if (!response.ok) {
        throw new Error("Failed to process voice message");
      }

      const result = await response.json();

      // Add user message (showing transcribed text)
      const userMessage: Message = {
        sender: PlayGroundEnum.USER,
        userData: {
          input: result.metadata?.transcribed_text || "Voice message",
          conversation_id: result.conversation_id || conversationId,
        },
      };

      // Add agent response with audio
      const agentMessage: Message = {
        sender: PlayGroundEnum.AGENT,
        agentData: {
          response: await marked.parse(result.response),
          rawResponse: result.response,
          conversation_id: result.conversation_id || conversationId,
          metadata: result.metadata,
          audioResponse: result.audio_response,
        },
      };

      setMessages((prev) => [...prev, userMessage, agentMessage]);
      setConversationId(result.conversation_id || conversationId);
      setChatHistoryId(result.chat_history_id || chatHistoryId);

      // Create audio URL for playback
      if (result.audio_response) {
        const audioFormat = result.metadata?.audio_format || 'mp3';
        const audioBlob = new Blob([Uint8Array.from(atob(result.audio_response), c => c.charCodeAt(0))], { type: `audio/${audioFormat}` });
        const audioUrl = URL.createObjectURL(audioBlob);
        setCurrentAudioUrl(audioUrl);

        // Auto-play the audio response
        const audio = new Audio(audioUrl);
        audio.play().catch(error => {
          console.log('Auto-play prevented:', error);
        });
      }

    } catch (error) {
      console.error('Voice message failed:', error);
      dispatch(ShowError('Failed to process voice message'));
    } finally {
      setBotTyping(false);
    }
  };

  const sendMessage = async () => {
    isCancelledStream.current = false;
    if (!userInput.trim()) return; // Hide Welcome messages

    // Check if userContext is available, if not, generate a guest user
    if (!userContext) {
      console.log('👤 No user context available, generating guest user');
      const guestUserId = crypto.randomUUID();
      const guestUserData = {
        id: guestUserId,
        name: 'Guest User',
        email: `${guestUserId}@dummy.zeaiq.com`,
        type: 'guest',
        timestamp: new Date().toISOString()
      };
      setUserContext(guestUserData);
      setUserId(guestUserId);

      // Notify parent window about guest user generation
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({
          type: 'GUEST_USER_GENERATED',
          message: 'Guest user generated for chat',
          data: guestUserData
        }, '*');
      }
    }

    setShowInitialMessage(false); // Hide Welcome messages
    const data: UserMessage = {
      input: userInput,
      conversation_id: conversationId ? conversationId : "",
    };

    // Create the request payload for the API
    const requestPayload = {
      input: userInput,
      conversation_id: conversationId ? conversationId : "",
      chat_history_id: chatHistoryId || undefined,
      metadata: {
        ...(pageContext && { page_context: pageContext }),
        ...(userContext && { user_context: userContext })
      }
    };

    console.log('📤 Sending message with payload:', requestPayload);
    console.log('📄 Page context available:', !!pageContext);
    console.log('📄 Page context value:', pageContext);
    console.log('👤 User context available:', !!userContext);
    console.log('👤 User context value:', userContext);
    userContext?.id && console.log('👤 User ID:', userContext.id);

    console.log('📄 Request payload JSON:', JSON.stringify(requestPayload, null, 2));

    // Add user message
    setMessages((prev) => [
      ...prev,
      { sender: PlayGroundEnum.USER, userData: data },
    ]);
    setUserInput("");
    setBotTyping(true);
    setShowQuestions(false);
    try {
      if (agents?.agent_metadata?.streaming) {
        const response = await fetch(
          `${AGENT}/${agentId}/execute?stream=true`,
          {
            method: "POST",
            headers: {
              "x-api-key": `${apiKey}`,
              "Content-Type": "application/json",
              Accept: "text/event-stream",
            },
            body: JSON.stringify(requestPayload),
            mode: "cors",
            credentials: "same-origin",
          }
        );

        if (!response.ok || !response.body) {
          throw new Error("Failed to stream");
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");

        // Add placeholder agent message
        setMessages((prev) => [...prev, { sender: PlayGroundEnum.AGENT, isMessageLike: null }]);

        let buffer = "";
        var content = "";
        var tool_calls: any[] = [];
        var references: any[] = [];

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          if (isCancelledStream.current) break;

          buffer += decoder.decode(value, { stream: true });

          const lines = buffer.split("\n");
          for (const line of lines) {
            if (line.startsWith("data: ")) {
              const jsonPart = line.replace(/^data: /, "").trim();

              if (jsonPart === "[DONE]") return;

              try {
                const parsed = JSON.parse(jsonPart);
                responseId.current = parsed.response_id;
                if (!parsed.is_complete) {
                  content += parsed.response; // Assign directly here
                  setConversationId(parsed.conversation_id);
                  tool_calls = parsed.metadata.tool_calls || [];
                  const sanitizedContent = await marked.parse(content);
                  setMessages((preVal) => {
                    let lastMsg = preVal[preVal.length - 1];
                    lastMsg = {
                      ...lastMsg,
                      agentData: {
                        response: sanitizedContent,
                        conversation_id: parsed.conversation_id,
                        response_id: parsed.response_id,
                        rawResponse: content,
                        metadata: {
                          tool_calls: tool_calls,
                          extra_data: { references: references },
                        },
                      },
                    };
                    // console.log(lastMsg)
                    return [...preVal.slice(0, preVal.length - 1), lastMsg];
                  });
                } else {
                  // Handle completion - extract chat history ID and other metadata
                  if (parsed.chat_history_id) {
                    setChatHistoryId(parsed.chat_history_id);
                    console.log('📚 Received chat history ID from streaming response:', parsed.chat_history_id);
                  }

                  if (parsed.metadata?.extra_data?.references) {
                    references = parsed.metadata.extra_data.references;
                    setMessages((preVal) => {
                      let lastMsg = preVal[preVal.length - 1];
                      lastMsg = {
                        ...lastMsg,
                        agentData: {
                          ...lastMsg.agentData,
                          response: lastMsg.agentData?.response || "",
                          conversation_id: lastMsg.agentData?.conversation_id || "",
                          response_id: lastMsg.agentData?.response_id || parsed.response_id,
                          metadata: {
                            tool_calls: tool_calls,
                            extra_data: { references: references },
                          },
                        },
                      };
                      // console.log(lastMsg)
                      return [...preVal.slice(0, preVal.length - 1), lastMsg];
                    });
                  }
                  if (parsed.is_chart && parsed.response) {
                    try {
                      const chartData = JSON.parse(parsed.response);
                      setMessages((preVal) => {
                        let lastMsg = preVal[preVal.length - 1];
                        lastMsg = {
                          ...lastMsg,
                          agentData: {
                            response: "",
                            rawResponse: parsed.response,
                            response_id: parsed.response_id,
                            chartData: chartData,
                            metadata: {
                              tool_calls: tool_calls,
                              extra_data: { references: references },
                            },
                          },
                        };
                        return [...preVal.slice(0, preVal.length - 1), lastMsg];
                      });
                    } catch (chartError) {
                      console.error("Failed to parse chart data:", chartError);
                    }
                  }
                }
              } catch (e) {
                console.error("Parse error:", jsonPart, e);
              }
            }
          }

          // Keep partial buffer (in case a line is split across chunks)
          buffer = lines[lines.length - 1];
        }
      } else {
        // streming is false

        const resData: any = await fetch(
          `${AGENT}/${agentId}/execute?stream=false`,
          {
            method: "POST",
            headers: {
              "x-api-key": `${apiKey}`,
              "Content-Type": "application/json",
              Accept: "text/event-stream",
            },
            body: JSON.stringify(requestPayload),
            mode: "cors",
            credentials: "same-origin",
          }
        );

        if (!resData.ok) {
          throw new Error("Failed to stream");
        }
        const responseData = await resData.json();
        responseId.current = responseData.response_id;
        setConversationId(responseData.conversation_id);

        // Extract chat history ID if present
        if (responseData.chat_history_id) {
          setChatHistoryId(responseData.chat_history_id);
          console.log('📚 Received chat history ID from non-streaming response:', responseData.chat_history_id);
        }

        const rawHtml: string = await marked.parse(responseData.response);
        const tool_calls = responseData.metadata.tool_calls || [];
        const extra_data = responseData.metadata.extra_data;
        console.log(responseData);
        setMessages((preVal) => {
          return [
            ...preVal,
            {
              sender: PlayGroundEnum.AGENT,
              agentData: {
                response: rawHtml,
                rawResponse: responseData.response,
                conversation_id: responseData.conversation_id,
                response_id: responseData.response_id,
                metadata: { tool_calls: tool_calls, extra_data: extra_data },
              },
            },
          ];
        });
        if (responseData.is_chart && responseData.response) {
          try {
            const chartData = JSON.parse(responseData.response);
            setMessages((preVal) => {
              return [
                ...preVal,
                {
                  sender: PlayGroundEnum.AGENT,
                  agentData: {
                    response: "",
                    rawResponse: responseData.response,
                    response_id: responseData.response_id,
                    chartData: chartData,
                    metadata: { tool_calls: tool_calls, extra_data: extra_data },
                  },
                },
              ];
            });
          } catch (chartError) {
            console.error("Failed to parse chart data:", chartError);
          }
        }
      }
    } catch (err) {
      console.error("Streaming failed:", err);
    } finally {
      setBotTyping(false);
    }
    setUserInput(""); // Hide Welcome messages
  };

  const clearChat = () => {
    isCancelledStream.current = true;

    setShowHistory(false);

    setMessages([]);
    setUserInput("");
    setBotTyping(false);
    setShowInitialMessage(true);
    setShowQuestions(true);

    // Clear chat history ID and remove from localStorage
    if (chatHistoryId && agentId && userContext?.id) {
      const userId = userContext.id; // Extract to local variable
      const storageKey = `zeaiq_chat_history_${agentId}_${userId}`;
      localStorage.removeItem(storageKey);
      console.log('🗑️ Cleared chat history ID from localStorage:', storageKey);

      // Also notify parent window about the chat history clearing
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({
          type: 'CHAT_HISTORY_CLEARED',
          agentId: agentId,
          userId: userId
        }, '*');
        console.log('🔄 Notified parent window about chat history clearing');
      }
    }
    setChatHistoryId("");
    handleClose();
  };

  // Debug function to show current chat history state
  const debugChatHistory = () => {
    console.log('🔍 Chat History Debug Info:');
    console.log('  Agent ID:', agentId);
    console.log('  User Context:', userContext);
    console.log('  Chat History ID:', chatHistoryId);
    console.log('  Conversation ID:', conversationId);

    if (agentId && userContext?.id) {
      const userId = userContext.id; // Extract to local variable
      const storageKey = `zeaiq_chat_history_${agentId}_${userId}`;
      const storedChatHistoryId = localStorage.getItem(storageKey);
      console.log('  Stored in localStorage:', storedChatHistoryId);
    }

    // List all chat histories in localStorage
    const allChatHistories: Record<string, string | null> = {};
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith('zeaiq_chat_history_')) {
        allChatHistories[key] = localStorage.getItem(key);
      }
    }
    console.log('  All chat histories in localStorage:', allChatHistories);
  };

  const [chatHistories, setChatHistories] = useState<{
    items: ChatHistoryItem[];
    pagination?: { total: number; page: number; perPage: number };
  }>({
    items: [],
    pagination: { total: 0, page: 1, perPage: 10 },
  });
  console.log(chatHistories, "chatHistories");
  //  `http://localhost:8000/api/chat-history/list?user_id=123&page=1&page_size=20&agent_id=acd3c34f-cf46-4571-8988-ac2e8a0eacae`, {


  const getHistory = async (page: number = 1, pageSize: number = 10) => {
    // Guard against missing user ID
    if (!userId) {
      console.log('⚠️ Cannot fetch history: no user ID available');
      return;
    }

    try {
      dispatch(StartLoading());
      const response = await fetch(
        `${CHAT_HISTORY}?user_id=${userId}&page=${page}&page_size=${pageSize}&agent_id=${agentId}`,
        {
          method: "GET",
          headers: {
            "x-api-key": `${apiKey}`,
            "Content-Type": "application/json",
          },
          mode: "cors",
          credentials: "same-origin",
        }
      );
      const data = await response.json();

      const items = (data.items || []).map((item: ChatHistoryItem) => ({
        ...item,
        first_message_preview: cleanShortcutPreview(item.first_message_preview),
        last_message_preview: cleanShortcutPreview(item.last_message_preview),
      }));

      setChatHistories({
        items: items,
        pagination: data.pagination || {
          total: data.total || 0,
          page: page,
          perPage: pageSize,
        },
      });
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }
  };


  useEffect(() => {
    if (userId) {
      console.log(userId, "userId ndu");
      if (agents?.agent_metadata?.user_context_awareness) {
        getHistory();
      }
    }
  }, [showHistory, userId, userContext?.id]);

  const handlePageChange = (page: number) => {
    if (agents?.agent_metadata?.user_context_awareness) {
      getHistory(page, chatHistories.pagination?.perPage || 10);
    }
  };


  const handleClick = (option: string) => {
    console.log(`Selected option: ${option}`);
    // For chips at the bottom
    if (option) {
      setUserInput(option);
      inputRef.current?.focus();
    }
  };

  // Smooth Scrolling to Bottom on New Message
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClickDots = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleViewRecentChats = () => {
    setShowHistory(true);
    handleClose();
  };
  const handleStartNewChat = () => {
    setShowHistory(false);
    clearChat();
    handleClose();
  };
  const handleEndChat = () => {
    clearChat();
    handleClose();
  };
  const handleBackToChat = () => {
    setShowHistory(false);
  };

  // Add this function to load chat history details

  const loadChatHistoryDetails = async (chatHistoryId: string) => {
    // Guard against missing user context
    if (!userContext?.id) {
      console.log('⚠️ Cannot load chat history: no user context available');
      return;
    }

    try {
      dispatch(StartLoading());
      const response = await fetch(
        `${CHAT_HISTORY_DETAIL}/${chatHistoryId}/detail`,
        {
          method: "GET",
          headers: {
            "x-api-key": `${apiKey}`,
            "Content-Type": "application/json",
          },
          mode: "cors",
          credentials: "same-origin",
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch chat history details");
      }

      const chatDetails: ChatHistoryDetail = await response.json();


      // Set the conversation ID from the loaded chat
      setConversationId(chatDetails.conversation_id);

      // Convert the chat history format to the Message format used in the component
      const convertedMessages: Message[] = [];

      for (const msg of chatDetails.messages) {
        // User message
        convertedMessages.push({
          sender: PlayGroundEnum.USER,
          userData: {
            input: cleanShortcutLabel(msg.user_message),
            conversation_id: msg.agent_response.conversation_id,
          },
        });

        // Agent message - Parse the response through markdown to preserve formatting
        const parsedResponse = await marked.parse(msg.agent_response.response);
        convertedMessages.push({
          sender: PlayGroundEnum.AGENT,
          agentData: {
            response: parsedResponse, // Use parsed HTML instead of plain text
            rawResponse: msg.agent_response.response,
            metadata: {
              tool_calls: msg.agent_response.metadata.tool_calls || [],
              extra_data: msg.agent_response.metadata.extra_data || {},
            },
          },
        });
      }

      // Set the messages
      setMessages(convertedMessages);

      // Hide the initial message and questions since we now have conversation history
      setShowInitialMessage(false);
      setShowQuestions(false);

      // Hide the history view and show the chat
      setShowHistory(false);

      // Set the chat history ID
      setChatHistoryId(chatHistoryId);

      console.log('📚 Loaded chat history details:', {
        conversationId: chatDetails.conversation_id,
        messageCount: chatDetails.message_count,
        messages: convertedMessages.length
      });

    } catch (err: any) {
      console.error("Error loading chat history details:", err);
      // dispatch(ShowError("Failed to load chat history"));

    } finally {
      dispatch(StopLoading());
    }
  };

  // Add this function to handle chat item selection from history
  const handleChatHistorySelect = (chatHistoryId: string) => {
    // Guard against missing user context
    if (!userContext?.id) {
      console.log('⚠️ Cannot select chat history: no user context available');
      return;
    }
    loadChatHistoryDetails(chatHistoryId);
  };

  const callLastChatHistory = (historyId: string) => {
    // Guard against missing user context
    if (agents?.agent_metadata?.user_context_awareness) {
      if (!userContext?.id) {
        console.log('⚠️ Cannot call last chat history: no user context available');
        return;
      }
    }
    loadChatHistoryDetails(historyId);
  }

  // call last chat history
  useEffect(() => {
    if (agents?.agent_metadata?.user_context_awareness) {
      callLastChatHistory(chatHistoryId);
    }
  }, [chatHistoryId]);

  return (
    <Box
      sx={{ width: "100vw", height: "100vh", p: 0, m: 0, background: "#fff", }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          width: "100vw", // Make it full width
          marginLeft: 0, // Remove centering
          marginRight: 0,
          borderColor: "rgba(24, 24, 27, .1)",
          borderRadius: "30px",
          backgroundColor: "#fff",
          background: agentTheme.backgroundColor,
          overflow: "hidden",
          boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Header */}
        <Box
          position="sticky"
          sx={{
            backgroundColor: "#fff",
            borderBottom: "1px solid #f9f7f7",
            px: 4,
            py: 1.5,
            //height: "45px",
            display: showHistory ? "none" : "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: agentTheme.backgroundColor,
            boxShadow: "0 15px 30px 0 rgba(256, 256, 256, 1)",
            zIndex: 1,
            top: 0,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
              }}
            >
              <img
                src={LogoIcon}
                alt="Company Logo"
                style={{ width: 30, height: "auto" }}
              />
            </Box>
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1, textTransform: "capitalize", color: agentTheme.titleColor, }}
            >
              {agents?.name || "Chat"}
            </Typography>
          </Box>

          <Box>

            <IconButton
              id="demo-positioned-button"
              aria-controls={open ? "demo-positioned-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClickDots}
            >
              <MoreHorizIcon />
            </IconButton>
            <Menu
              id="demo-positioned-menu"
              aria-labelledby="demo-positioned-button"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              PaperProps={{
                elevation: 0, // Disable default MUI shadow
                sx: {
                  boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
                  borderRadius: 2,
                },
              }}
            >
              <MenuItem onClick={handleStartNewChat}>
                <ListItemIcon>
                  <NewChatIcon />
                </ListItemIcon>
                <ListItemText>Start a new chat</ListItemText>
              </MenuItem>
              {/* <MenuItem onClick={clearChat}>
                <ListItemIcon>
                  <CachedIcon />
                </ListItemIcon>
                <ListItemText>Clear chat</ListItemText>
              </MenuItem> */}

              <MenuItem onClick={handleEndChat}>
                <ListItemIcon>
                  <EndChatIcon />
                </ListItemIcon>
                <ListItemText>End chat</ListItemText>
              </MenuItem>

              {agents?.agent_metadata?.user_context_awareness && (
                <MenuItem onClick={handleViewRecentChats}>
                  <ListItemIcon>
                    <RecentChatIcon />
                  </ListItemIcon>
                  <ListItemText>View recent chats</ListItemText>
                </MenuItem>
              )}
            </Menu>
          </Box>

        </Box>
        {/* Chat Messages */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            height: "calc(100% - 130px)",
            alignItems: showHistory ? "flex-start" : "center",
            p: 0,
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              maxHeight: "100%",
              overflow: "auto",
              p: showHistory ? 0 : 4,
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0, 0, 0, 0.2)",
                borderRadius: "3px",
              },
              "&::-webkit-scrollbar-thumb:hover": {},
              "&::-webkit-scrollbar-track": {},
            }}
          >
            {/* Main Text */}

            {showHistory ? (
              <RecentChatsByUser
                historyData={chatHistories}
                onPageChange={handlePageChange}
                onBack={handleBackToChat}
                clearChat={clearChat}
                onChatSelect={handleChatHistorySelect} // Add this prop
              />
            ) : (
              // Chat View
              <>
                {/* Main Text */}
                {showInitialMessage && (
                  <PlayGroundInitialMessage message={initialMessage} incomingTextColor={agentTheme.incomingChatTextColor} />
                )}
              </>
            )}



            {messages.map((msg, index) => (
              <Box
                key={index}
                sx={{
                  display: showHistory ? "none" : "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  mb: 3,
                }}
              >
                <Box sx={{ width: "100%" }}>
                  {/* Tool chips visible for all messages */}
                  {msg?.agentData?.metadata?.tool_calls &&
                    msg?.agentData?.metadata?.tool_calls?.length > 0 && (
                      <AgentPlayGroundTools
                        tools={msg?.agentData.metadata.tool_calls || []}
                      />
                    )}

                  {/* Bot Message */}
                  {msg.sender === PlayGroundEnum.AGENT ? (
                    <Box sx={{ display: "flex" }}>
                      <Box
                        sx={{
                          display: "flex",
                          mr: 2,
                          height: "24px",
                        }}
                      >
                        <img
                          src={LogoIcon}
                          alt="Company Logo"
                          style={{ width: 24, height: "auto" }}
                        />
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          width: "100%",
                        }}
                      >
                        {/* Accordion: Reasoned Explanation */}
                        {msg?.agentData?.metadata && (
                          <></>
                          // <Box
                          //   sx={{
                          //     mb: 1,
                          //   }}
                          // >
                          //   {msg.reasoned.map((link, idx) => (
                          //     <Accordion
                          //       key={idx}
                          //       disableGutters
                          //       elevation={0}
                          //       square
                          //       sx={{
                          //         backgroundColor: "transparent",
                          //         "&:before": { display: "none" },
                          //       }}
                          //     >
                          //       <AccordionSummary
                          //         expandIcon={<ExpandMoreIcon />}
                          //         sx={{
                          //           px: 0,
                          //           py: 0,
                          //           width: "auto",
                          //           minHeight: "unset",
                          //           "& .MuiAccordionSummary-content": {
                          //             margin: 0,
                          //           },
                          //         }}
                          //       >
                          //         <Typography variant="body2">
                          //           Reasoned {link.title}
                          //         </Typography>
                          //       </AccordionSummary>
                          //       <AccordionDetails
                          //         sx={{
                          //           p: 0,
                          //           pl: 2,
                          //           py: 0.5,
                          //           borderLeft: "3px solid #ececec",
                          //           my: 1,
                          //         }}
                          //       >
                          //         <Typography
                          //           variant="body2"
                          //           sx={{ color: variables.textGray }}
                          //         >
                          //           {link.content}
                          //         </Typography>
                          //         {/* <Divider sx={{ my: 1 }} /> */}
                          //       </AccordionDetails>
                          //     </Accordion>
                          //   ))}
                          // </Box>
                        )}

                        {/* Main Text */}
                        <Typography
                          key={index}
                          variant="body2"
                          component="div"
                          sx={{
                            color: agentTheme.incomingChatTextColor,
                            whiteSpace: "normal",
                            "& table": {
                              borderCollapse: "collapse",
                              width: "100%",
                              margin: "8px 0",
                            },
                            "& th, & td": {
                              border: "1px solid #bdbdbd",
                              padding: "6px 10px",
                            },
                            "& th": {
                              background: "#f5f5f5",
                              fontWeight: 600,
                            },
                          }}
                          dangerouslySetInnerHTML={{
                            __html: msg?.agentData?.response || "...",
                          }}
                        />

                        {/* Audio Response */}
                        {msg?.agentData?.audioResponse && (
                          <Box sx={{ mt: 1, mb: 1 }}>
                            <VoiceRecorder
                              onRecordingComplete={() => { }}
                              disabled={true}
                              size="small"
                              showPlayback={true}
                              showMicIcon={false}
                              audioUrl={(() => {
                                try {
                                  // Use audio format from metadata, fallback to mp3
                                  const audioFormat = msg?.agentData?.metadata?.audio_format || 'mp3';
                                  const audioBlob = new Blob([Uint8Array.from(atob(msg.agentData.audioResponse), c => c.charCodeAt(0))], { type: `audio/${audioFormat}` });
                                  return URL.createObjectURL(audioBlob);
                                } catch (error) {
                                  console.error('Error creating audio URL:', error);
                                  return undefined;
                                }
                              })()}
                            />
                          </Box>
                        )}

                        {/* Chart */}
                        {msg?.agentData?.chartData && (
                          <PlotlyChart
                            data={msg.agentData.chartData.data || []}
                            layout={msg.agentData.chartData.layout || {}}
                            config={msg.agentData.chartData.config || { displayModeBar: false }}
                          />
                        )}

                        {/* propmts and short cuts */}
                        <AgentPrompts
                          agentShortuts={agentShortcuts}
                          messageId={index}
                          sendMessageShortcuts={sendMessageShortcuts}
                          messages={messages}
                          setMessages={setMessages}
                          agentId={agentId}
                          responseId={msg.agentData?.response_id}
                          conversationId={conversationId}
                          apiKey={apiKey}
                          useApiKey={true}
                        />
                        {/* {msg?.agentData?.response || '...'}
                        </Typography> */}

                        {/* References */}
                        {msg.agentData?.metadata?.extra_data && (
                          <AgentPlaygroundReferences
                            data={msg.agentData?.metadata?.extra_data}
                            incomingTextColor={agentTheme.incomingChatTextColor}
                            setShowCitations={setShowCitations}
                          />
                        )}
                      </Box>
                    </Box>
                  ) : (
                    // User Message
                    <Box sx={{ display: "flex" }}>
                      <Avatar
                        variant="rounded"
                        sx={{
                          width: 24,
                          height: 24,
                          borderRadius: "50%",
                          bgcolor: variables.blackColor,
                          mr: 2,
                          p: "3px",

                        }}
                      >
                        <LineMdAccount />
                      </Avatar>
                      <Typography
                        variant="body2"
                        sx={{ lineHeight: "24px", whiteSpace: "pre-wrap", color: agentTheme.outgoingChatTextColor }}
                        dangerouslySetInnerHTML={{ __html: msg?.userData?.input || "" }}
                      />
                      {/* {msg?.userData?.input} */}
                      {/* </Typography> */}
                    </Box>
                  )}
                </Box>
                <div ref={endOfMessagesRef} />
              </Box>
            ))}

            {botTyping && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  mb: 3,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    mr: 2,
                    height: "24px",
                  }}
                >
                  <img
                    src={LogoIcon}
                    alt="Company Logo"
                    style={{ width: 24, height: "auto" }}
                  />
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", height: 24 }}>
                  <TypingIndicator />
                </Box>
              </Box>
            )}
          </Box>
        </Box>

        {/* Input Field */}

        {!showHistory && (
          <Box
            sx={{
              display: "flex",
              gap: 1,
              alignItems: "flex-start",
              p: 2,
              bgcolor: "rgba(255, 255, 255, 0.2)",
              width: "100%",
              position: "sticky",
              bottom: 0,
              borderTop: "1px solid rgba(24, 24, 27, .1)",
              flexDirection: "column",
            }}
          >
            {/* Default questions always above input */}
            {showQuestions && agentId && (
              <AgentQuestions
                sendMessageQuestions={sendMessageQuestions}
                agentId={agentId}
              />
            )}

            <Box
              sx={{
                border: "1px solid rgba(24, 24, 27, .1)",
                boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
                borderRadius: "20px",
                width: "100%",
                position: "relative",
                padding: "12px 16px",
                background: "#fff",
              }}
            >
              <TextField
                fullWidth
                multiline
                variant="outlined"
                size="small"
                maxRows={4}
                placeholder="Ask anything..."
                value={userInput}
                onChange={(e) => setUserInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    sendMessage();
                  }
                }}
                inputRef={inputRef}
                disabled={botTyping}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    fontSize: "14px",
                    maxHeight: "120px", // Add maximum height
                    overflowY: "auto", // Enable vertical scrolling
                    pr: "40px", // Space for the send button
                    "&::-webkit-scrollbar": {
                      width: "6px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "rgba(0, 0, 0, 0.2)",
                      borderRadius: "3px",
                    },
                    "& fieldset": {
                      border: "none",
                    },
                    "&:hover fieldset": {
                      border: "none",
                    },
                    "&.Mui-focused fieldset": {
                      border: "none",
                    },
                  },
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  bottom: "10px",
                  right: "10px",
                  display: "flex",
                  gap: 1,
                  alignItems: "center",
                }}
              >
                {agents?.agent_metadata?.voice_enabled && (
                  <VoiceRecorder
                    onRecordingComplete={sendVoiceMessage}
                    disabled={botTyping}
                    size="small"
                  />
                )}
                <Button
                  onClick={sendMessage}
                  disabled={botTyping || !userInput}
                  sx={{
                    width: 40,
                    height: 40,
                    background: variables.primaryColor,
                    color: variables.whiteColor,
                    minWidth: 0,
                    borderRadius: "50%",
                    "&.Mui-disabled": {
                      color: variables.whiteColor,
                      opacity: 0.5,
                    },
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M10 14L21 3m0 0l-6.5 18a.55.55 0 0 1-1 0L10 14l-7-3.5a.55.55 0 0 1 0-1z"
                    />
                  </svg>
                </Button>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default IFrameAgent;
